import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';

export interface PromptOption {
  id: string;
  text: string;
}

export interface PromptUserPayload {
  text: string;
  allow_freeform: boolean;
  options: PromptOption[];
}

@Component({
  selector: 'app-prompt-user',
  standalone: true,
  imports: [CommonModule, FormsModule, MatButtonModule],
  templateUrl: './prompt-user.component.html',
  styleUrl: './prompt-user.component.scss',
})
export class PromptUserComponent implements OnChanges {
  @Input({ required: true }) prompt!: PromptUserPayload;
  @Input() disabled: boolean = false;

  @Output() send = new EventEmitter<string>();

  get payload(): PromptUserPayload {
    return this.prompt;
  }

  otherText = '';
  hasSent = false;
  selectedOptionId: string | null = null;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['prompt']) {
      this.resetLocalState();
    }
  }

  optionLetter(index: number): string {
    // A, B, ..., Z, AA, AB, ...
    const base = 26;
    let n = index + 1;
    let out = '';
    while (n > 0) {
      n -= 1;
      out = String.fromCharCode(65 + (n % base)) + out;
      n = Math.floor(n / base);
    }
    return out;
  }

  selectOption(optionId: string): void {
    if (this.disabled || this.hasSent) return;
    // Clicking the selected option again clears it
    this.selectedOptionId = this.selectedOptionId === optionId ? null : optionId;

    // Mutually exclusive with Other…
    if (this.selectedOptionId) this.otherText = '';
  }

  onOtherFocus(): void {
    if (this.disabled || this.hasSent) return;
    this.selectedOptionId = null;
  }

  onOtherTextChange(text: string): void {
    if (this.disabled || this.hasSent) return;
    this.otherText = text;
    if (String(text ?? '').trim()) this.selectedOptionId = null;
  }

  submit(): void {
    if (this.selectedOptionId) {
      const selected = this.payload.options.find((opt) => opt.id === this.selectedOptionId);
      this.emitOnce(selected?.text ?? '');
    } else if (this.payload.allow_freeform) {
      this.emitOnce(this.otherText);
    }
  }

  private emitOnce(text: string): void {
    if (this.disabled || this.hasSent) return;
    const trimmed = String(text ?? '').trim();
    if (!trimmed) return;
    this.hasSent = true;
    this.send.emit(trimmed);
  }

  private resetLocalState(): void {
    this.otherText = '';
    this.hasSent = false;
    this.selectedOptionId = null;
  }
}

